import ClubAdditionalFiltersButton from '../../components/clubs/clubAdditionalFiltersButton'
import ClubFilterForm from '../../components/clubs/clubFilterForm'
const ClubsAdditionalFilters = props => {
	return props.context === 'button' ? (
		<ClubAdditionalFiltersButton {...props} />
	) : (
		<ClubFilterForm {...props} />
	)
}
export default ClubsAdditionalFilters